import { useMemo } from 'react';

export type FieldState =
  | 'default'
  | 'error'
  | 'disabled'
  | 'disabledError'
  | 'submitting'
  | 'submittingDirty'
  | 'dirty'
  | 'disabledDirty'
  | 'readOnly';

export interface WithFieldStateProps {
  disabled?: boolean;
  readOnly?: boolean;
  error?: boolean;
  submitting?: boolean;
  dirty?: boolean;
}

export const useFieldState = (props: WithFieldStateProps) => {
  const { disabled, readOnly, error, submitting, dirty } = props;

  const stateVariant: FieldState = useMemo(() => {
    if (submitting && dirty) return 'submittingDirty';
    else if (submitting) return 'submitting';
    else if (readOnly) return 'readOnly';
    else if (disabled && error) return 'disabledError';
    else if (disabled && dirty) return 'disabledDirty';
    else if (disabled) return 'disabled';
    else if (error) return 'error';
    else if (dirty) return 'dirty';
    return 'default';
  }, [submitting, dirty, readOnly, disabled, error]);

  return stateVariant;
};
